/** Small composed-tree focus helpers shared by inline controls and overlays. */

/** Returns focus through any number of open shadow roots. */
export function deepActiveElement(root: Document | ShadowRoot = globalThis.document): HTMLElement | null {
  let active = root.activeElement;
  while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
  return active instanceof HTMLElement ? active : null;
}

/** Includes slotted descendants and nodes inside open shadow roots. */
export function overlayContains(owner: Node, node: Node | null): boolean {
  while (node) {
    if (node === owner) return true;
    node = (node as HTMLElement).assignedSlot || node.parentNode || (node as ShadowRoot).host || null;
  }
  return false;
}

/**
 * Bind to a component and listen on its non-tabbable native validation input.
 * Let native validation finish before forwarding focus to the public control.
 * The owner must remove the same listener on disconnect.
 */
export function redirectValidationFocus(this: HTMLElement, event: FocusEvent): void {
  const anchor = event.currentTarget;
  queueMicrotask(() => {
    if (anchor && this.isConnected && this.shadowRoot?.activeElement === anchor) this.focus();
  });
}
